import Script from "next/script";
import { useConsent } from "../contexts/ConsentContext";

// Third-party scripts that set cross-site cookies are injected only for the
// categories the visitor allows. Before any consent the page loads zero
// third-party cookies — PDPA-friendly and lets Lighthouse (which never
// consents) pass the "third-party-cookies" audit. Google Analytics stays in
// _app.tsx: first-party cookies under Consent Mode, not gated here.
export default function ConsentGatedScripts() {
  const { prefs, decided } = useConsent();

  if (!decided) return null;

  return (
    <>
      {prefs.advertising && (
        <Script
          id="adsbygoogle-loader"
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-6015892276154863"
          strategy="lazyOnload"
          crossOrigin="anonymous"
        />
      )}
      {prefs.analytics && (
        <Script id="clarity-init" strategy="lazyOnload">
          {`
            (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
            })(window, document, "clarity", "script", "vfcjkqext9");
          `}
        </Script>
      )}
    </>
  );
}
